import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveWiggle12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoveWiggle12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M2.906 3.943c.027.598-.294 1.022-.506 1.312-.235.322-.36.51-.358.759.001.245.126.433.36.755.21.289.527.712.504 1.3-.019.474-.248.99-.433 1.343a7 7 0 0 1-.355.598l-.025.038-.007.01-.003.003v.001a.45.45 0 1 1-.738-.515l.005-.007.02-.03a6 6 0 0 0 .306-.517c.178-.34.32-.702.33-.96.01-.236-.102-.418-.332-.734-.205-.283-.528-.7-.531-1.28-.003-.59.323-1.01.53-1.295.232-.316.345-.499.334-.74-.012-.26-.155-.626-.334-.971a6 6 0 0 0-.306-.527l-.02-.03-.004-.007h-.001a.45.45 0 0 1 .743-.509v.002l.003.003.008.01.025.039.087.138c.071.116.167.279.265.467.184.356.412.874.433 1.344M8.174 6a2.174 2.174 0 1 1-4.348 0 2.174 2.174 0 0 1 4.348 0m-.9 0a1.273 1.273 0 1 0-2.547 0 1.273 1.273 0 0 0 2.546 0m3.58.02c-.003.58-.326.997-.53 1.28-.23.316-.343.498-.334.734.01.258.153.62.331.96a6 6 0 0 0 .306.518l.02.029.004.007h.001a.45.45 0 1 1-.738.515l-.003-.004-.007-.01-.025-.038-.088-.136a7 7 0 0 1-.267-.462c-.185-.354-.414-.87-.433-1.343-.023-.588.294-1.011.504-1.3.234-.322.359-.51.36-.755.001-.25-.123-.437-.358-.76-.212-.289-.533-.713-.506-1.31.021-.47.249-.989.433-1.346a7 7 0 0 1 .352-.604l.025-.038.008-.01.002-.004h.001V1.94a.45.45 0 0 1 .743.508v.001l-.006.007-.02.03-.073.118a6 6 0 0 0-.232.409c-.178.345-.322.712-.334.971-.01.24.102.424.333.74.208.285.534.705.531 1.294"
            />
        </svg>
    );
}
export default memo(IconMoveWiggle12);
